<template>
  <div>
    <div id="box" style="display: none;">
    </div>
    <!-- <div class="box"></div> -->
    <!-- 定部 -->
    <div class="header">
      <div class="header-l" @click="navto(1)">
        <img src="../../../assets/images/手机端/首页手机端/logo拷贝.png" alt="">
      </div>
      <div id="btn" class="header-r" @click="addnav">
        <img src="../../../assets/images/手机端/首页手机端/更多.png" alt="">
      </div>
    </div>
    <div class="top-img">
      <img src="../../../assets/images/手机端/关于我们 手机端/图层871@2x.png" alt="">
      <div class="top-center">
        <h3>关于掌网</h3>
        <p>
          温州掌网信息技术有限公司（简称：掌网信息）成立于2013年，公司位于浙江省温州市鹿城区，是一家专业数智一体化解决方案服务商，致力于用“创新+技术”赋能政企单位信息化数字化改革进程。自主研发的域贝大数据平台、域贝一体化平台等产品应用于公安、教育、政企等行业数字化建设。
        </p>
        <!-- <p style="margin-top: 0;">
          掌网信息是浙江省高成长科技型中小企业，拥有数十项发明专利和软件著作权。</p> -->
        <div class="top-bottom">
          <div class="top-botom-1">
            <div class="text">
              <h3>产品理念</h3>
            </div>
            <p>
              掌网信息坚持“精致的实用主义”的产品理念，“以客户为中心”的服务理念，“以创新为核心”的经营理念，持续不断地为客户创造价值。公司主要创始人拥有二十多年的信息化系统项目管理经验，是温州市科技局信息化项目评审专家、温州市重大科技创新攻关项目评审专家。公司在大数据应用、一体化平台、人工智能建设等多个领域有丰富的项目经验和技术实力，严格遵循信息系统项目管理标准，拥有一支技术全面、服务优良、结构完整的专业软件开发和服务团队，成功服务于众多客户，通过优质的产品和周到的服务，赢得了市场良好的口碑。
            </p>

          </div>
        </div>
      </div>
    </div>

    <div class="main-1">
      <h3>选择掌网的四大理由</h3>
      <ul>
        <li>
          <h3>项目简历</h3>
          <p>公司在大数据应用、一体化平台建设等多个领域有丰富的项目经验和技术实力</p>
        </li>
        <li>
          <h3>遵循标准</h3>
          <p>我们严格遵循信息系统项目管理标准</p>
        </li>
        <li>
          <h3>服务团队</h3>
          <p>掌网信息拥有一支技术全面、服务优良、结构完整的专业软件开发和服务团队</p>
        </li>
        <li>
          <h3>市场口碑</h3>
          <p>成功服务于众多客户，通过优质的产品和周到的服务，赢得了市场良好的口碑</p>
        </li>
      </ul>
    </div>
    <!-- <div class="tixi">
      <h3 class="cpjiazhi">完整的产品体系</h3>
      <div class="img">
        <img src="../../../assets/images/手机端/关于我们 手机端/产品体系@2x.png" alt="">
      </div>
    </div> -->
    <div class="hezuo">
      <ul>
        <li><img src="../../../assets/images/手机关于我们/平阳县公安局.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/平阳县公安局分局.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/温州市公安局苍南分局.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组33.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组34.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组35.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组38.png" alt=""></li>
      </ul>
      <ul class="ullis">
        <li><img src="../../../assets/images/手机关于我们/组39.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组40.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组40.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组41.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组45.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组43.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组44.png" alt=""></li>
      </ul>
      <ul class="ullis1">
        <li><img src="../../../assets/images/手机关于我们/组46.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组47.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组48.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组49.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/组50.png" alt=""></li>
        <li><img src="../../../assets/images/手机关于我们/鹿城公安.png" alt=""></li>
      </ul>
    </div>
    <div class="footer">
      <ul>
        <li @click="goyuzan">
          <p>玉瓒云校园</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu = !subMenu">
          <p>一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'visualizationpage' })">
          <p>产品详情</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'pricepage' })">
          <p>产品定价</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu2 = !subMenu2">
          <p>域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="goproductservice">
          <p>域贝证书宝</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="gointegratedpage">
          <p>域贝一体化</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="godate">
          <p>域贝大数据</p>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <div class="logn">
        <img src="../../../assets/images/手机端/首页 手机端/logo.png" alt="">
      </div>
      <div class="dianhua">
        <p><img src="../../../assets/images/手机端/首页 手机端/电话(1).png" alt="">400-051-0806</p>
      </div>
      <div class="dizhi">
        <p><img src="../../../assets/images/手机端/首页 手机端/地址.png" alt="">浙江省温州市鹿城区车站大道11号高联大厦1608室</p>
      </div>
      <img @click="iswei" class="erweima" src="../../../assets/images/手机端/首页手机端/二维码.png" alt="">

      <div class="footer-bottom">
        <p>备案号：浙ICP备13031672</p>
      </div>
    </div>
    <div class="mask"></div>
    <div class="mask"></div>
    <div class="mask1"></div>
    <div class="erweima1">
      <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt="">
    </div>
    <div class="ismask" @click.self="qiemask" v-show="ismask">
      <div class="isnav" v-show="isnav">
        <ul>
          <li @click="navto(1)">首页</li>
          <li @click="navto(9)">玉瓒云校园</li>
          <li @click="subMenu = !subMenu">一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu" class="subLi" @click="navto(7)">产品详情</li>
          <li v-if="subMenu" class="subLi" @click="navto(8)">产品定价</li>
          <li @click="subMenu2 = !subMenu2">域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu2" class="subLi" @click="navto(2)">域贝证书宝</li>
          <li v-if="subMenu2" class="subLi" @click="navto(3)">域贝大数据</li>
          <li v-if="subMenu2" class="subLi" @click="navto(4)">域贝一体化</li>
          <!-- <li @click="navto(2)">域贝证书宝</li>
          <li @click="navto(3)">域贝大数据</li>
          <li @click="navto(4)">域贝一体化</li> -->
          <li @click="navto(5)">解决方案</li>
          <li @click="navto(6)">关于掌网</li>
        </ul>
      </div>
    </div>
    <div v-show="isweixiang" class="iserweima" @click.stop.self.prevent="isis">
      <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isnav: false,
      ismask: false,
      isweixiang: false,
      subMenu: false,
      subMenu2: false
    }
  },
  methods: {
    iswei() {
      this.isweixiang = true
    },
    isis() {
      this.isweixiang = false
    },
    goproductservice() {
      this.$router.push({ path: 'hoproductservicepage' })
    },
    godate() {
      this.$router.push({ path: 'hodate' })
    },
    goyuzan() {
      window.location.href='http://www.yuzanyun.com'
    },
    gointegratedpage() {
      this.$router.push({ path: 'integratedpage' })
    },
    addnav() {
      this.ismask = !this.ismask
      this.isnav = !this.isnav
    },
    qiemask() {
      // console.log(111);
      this.ismask = false
      this.isnav = false
    },
    navto(n) {
      if (n == 1) {
        this.$router.push({ path: 'index' })
      } else if (n == 2) {
        this.$router.push({ path: 'hoproductservicepage' })
      } else if (n == 3) {
        this.$router.push({ path: 'hodate' })

      } else if (n == 4) {
        this.$router.push({ path: 'integratedpage' })
      } else if (n == 5) {
        this.$router.push({ path: 'cooperationpage' })
      } else if (n == 6) {
        this.ismask = false
        this.isnav = false
      } else if (n == 7) {
        this.$router.push({ path: 'visualizationpage' })
      } else if (n == 8) {
        this.$router.push({ path: 'pricepage' })
      } else if (n == 9) {
        window.location.href='http://www.yuzanyun.com'
      }
    }
  }
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
}

li {
  list-style: none;
}

p {
  margin: 0;
}

ul {
  margin: 0;
  padding: 0;
}

body {
  min-width: 320px;
  max-width: 750px;
  width: 15rem;
  margin: 0 auto;
  line-height: 1.5;
  font-family: PingFangSC-Regular, sans-serif;
  background: #F2F2F2;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  height: 2.4rem;
  padding-bottom: .4688rem;
  width: 100%;
  padding-top: .7031rem;
  background-color: #fff;
  z-index: 9999999999;
}

.header-l {
  float: left;
  margin-left: .75rem;
  /* background-image: url('../images/首页 手机端/logo.png'); */
}

.header-l img {
  height: .8rem;
  object-fit: cover;
}

.header-r {
  width: 1.75rem;
  height: 1.375rem;
  float: right;
}

.header-r img {
  width: .62rem;
  height: .5rem;
}

.top-img {
  margin-top: 2.4rem;
  /* padding-top: 9.9rem; */
  text-align: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: .4rem;
  //   width: 14rem;
  height: 19.04rem;
  background-size: 100%;
  background-color: #d9eafe;
  /* background-image: url('../images/电子证书 手机端(1)/首图背景.png'); */
}

.top-img img {
  margin-top: .84rem;
  width: 12.36rem;
  height: 6.94rem;
}

.top-img h3 {
  font-weight: 600;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: .72rem;
  margin-left: .5rem;
  margin: 0;
  color: #23405a;
}

.top-img .top-center {
  text-align: left;
  // margin-top: .4rem;
}

.top-img p {
  text-indent: 2em;
  margin-top: .64rem;
  margin-left: 0;
  margin-right: 0;
  font-size: .52rem;
  line-height: .72rem;
  color: #4d5b75;
}

.top-img .button {
  text-align: center;
  height: 0;
}

.top-img .button button {
  width: 3.04rem;
  height: 1.2rem;
  margin-top: .8rem;
  border: 1px solid #999 !important;
  /* background-color: rgba(255, 255, 255, 0.1); */
  background: transparent;
  border: 0px;
  color: #4d5b75;
  font-size: .52rem;
}

.top-bottom {
  margin-top: 1rem;
  //   width: 14.28rem;
  height: 12.38rem;
  padding: .4rem .4rem;
  margin-right: 0 !important;
  background-image: url('../../../assets/images/手机端/关于我们 手机端/组25@2x.png');
  background-repeat: no-repeat;
}

.top-botom-1 {
  padding-top: .2rem !important;
  //   width: 13.1rem;
  height: 11.6rem;
  padding: 0 .4rem;
  background-color: rgba(255, 255, 255, 0.8);
  margin-right: 0px !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.top-botom-1 p {
  margin-top: .4rem;
  line-height: .66rem;
}

.top-bottom .text {

  // text-align: center;
  // margin-left: 2.5rem;
  //   line-height: 100px;
  width: 8rem;
  //   height: 2rem;
  border-bottom: .02rem solid #dcdcdc;
}

.top-botom-1 .text h3 {
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .4rem;
}

.top-botom-1 .text p {
  text-indent: 2em;
  font-size: 22px;
  color: #4d5b75;
}

.main-1 {
  margin-top: 11rem;
  padding: 0 .6rem;
}

.main-1 h3 {
  margin-top: 0;
  padding-top: 1.6rem;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .8rem;
}

.main-1 ul {
  overflow: hidden;
}

.main-1 ul li {
  float: left;
  width: 48.5%;
  height: 6.48rem;
  background-color: pink;
  padding: .4rem;
}

.main-1 ul li:nth-child(1) {
  margin-right: .4rem;
  margin-bottom: .4rem;
  background-image: url('../../../assets/images/手机端/关于我们 手机端/组26@2x.png');
  background-size: 100% 100%;
}

.main-1 ul li:nth-child(2) {
  /* margin-right: .4rem; */
  margin-bottom: .4rem;
  background-image: url('../../../assets/images/手机端/关于我们 手机端/组27@2x.png');
  background-size: 100% 100%;
}

.main-1 ul li:nth-child(3) {
  margin-right: .4rem;
  background-image: url('../../../assets/images/手机端/关于我们 手机端/组28@2x.png');
  background-size: 100% 100%;
}

.main-1 ul li:nth-child(4) {
  /* margin-right: .4rem; */
  background-image: url('../../../assets/images/手机端/关于我们 手机端/组29@2x.png');
  background-size: 100% 100%;
}

.main-1 ul li h3 {
  padding: 0;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  font-size: .56rem;
  color: #fff !important;
  text-align: left;
  margin: 2.5rem 0 .36rem 0;
}

.main-1 ul li P {
  margin: 0;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: .48rem;
  line-height: .66rem;
  color: #fff !important;
  text-align: left;
}

.gojia {
  /* margin-bottom: 1.5625rem; */
  text-align: center;
  width: 100%;
}

.gojia h3 {
  margin-top: 0px;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: 1.6rem;
}

.gojia img {
  height: 8.8rem;
  width: 12.80rem;
}

.centre {
  padding: 0 .625rem;
}

.centre p {
  margin-top: .625rem;
  font-size: .375rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  color: #2c3e5c !important;

}

.centre button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  margin-top: .625rem;
  font-size: .52rem;
}

.tixi {
  text-align: center;
  padding-top: 1.6rem;
  padding-left: .4375rem;
  padding-right: .4375rem;
  margin-bottom: .4rem;
}

.tixi .img {
  margin-top: 1rem;
}

.tixi .img img {
  width: 13.18rem;
}

.tixi .cpjiazhi {
  margin: 0;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c;
  font-size: .72rem;
  margin-bottom: .4rem;
}

.jiazhi_rtext h3 {
  margin: 0 0 .4rem 0;
  font-weight: 400;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c;
  font-size: .56rem;
  text-align: left;
}

.jiazhi ul {
  margin-top: .8rem;
  padding: 0px;
  margin-bottom: 0;

}

.jiazhi ul li {

  padding: 0 .5625rem;
  padding-top: .52rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .5333rem;
  height: 4.28rem;
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.jiazhi p {
  margin-left: 0;
  text-align: left;
  font-size: .48rem;
  color: #4d5b75;
  /* margin-bottom: 40px; */
  margin-bottom: 0;
  font-family: PingFangSC-Regular, sans-serif;
}

.jiazhi .jiazhi_limg img {
  margin-top: .48rem;
  margin-right: .56rem;
  width: 3.1rem;
  height: 2.70rem;
  /* width: 1rem; */
  /* background-color: pink; */
}

.jiazhi button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  font-size: .375rem;
}

.main-2 {
  margin-top: 1.25rem;
  text-align: center;
  margin-bottom: .625rem;
}

.main-2 h3 {
  text-align: center;
  font-weight: normal;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .6933rem;
}

.main-2 img {
  margin-bottom: .625rem;
}

.main-2 p {
  font-size: .375rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  padding: 0 .875rem;
  color: #2c3e5c !important;
}

.main-3 {
  padding: 0 .8438rem;
}

.main-3 ul {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0px;
}

.main-3 ul li {
  /* float: left; */
  width: 48%;
  height: 3.9844rem;
  background-color: pink;
  margin-bottom: .3125rem;

  /* margin-left: .4688rem; */
}

.main-3 ul li:nth-child(1) {
  background-image: url('../../../assets/images/手机端/首页 手机端/组29.png');
  margin-right: .4688rem;
}

.main-3 ul li:nth-child(2) {
  background-image: url('../../../assets/images/手机端/首页 手机端/组30.png');
}

.main-3 ul li:nth-child(3) {
  margin-right: .4688rem;
  background-image: url('../../../assets/images/手机端/首页 手机端/组32.png');
}

.main-3 ul li:nth-child(4) {
  background-image: url('../../../assets/images/手机端/首页 手机端/组31.png');
}

.main-3 ul li {
  font-size: .375rem;
  font-weight: normal;
}

.main-3 ul li h3 {
  margin-top: .2813rem !important;
  margin-left: .2813rem !important;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
}

.main-3 ul li h4 {
  margin-top: .2813rem;
}

.main-3 ul li p {
  margin-top: .125rem;

  font-size: .1875rem;
  margin-bottom: .25rem;
}

.main-3 ul li h3,
h4,
p {
  font-weight: normal;
  margin: 0px .2813rem;
  color: #fff;
}

.main-3 ul li p {}

.main-3-botton {
  background-image: url('../../../assets/images/手机端/首页 手机端/组33.png');
  height: 3.9844rem;
}

.main-3-botton h3 {
  font-weight: normal;
  margin-top: 0;
  font-size: .6933rem !important;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #fff;
  margin-left: .2813rem;
  margin-top: .2813rem;
  margin-bottom: 0;
}

.main-3-botton p {
  font-family: PingFangSC-Regular, sans-serif;
  color: #fff;
  font-size: .5625rem;
}

.main-3-botton h4 {
  font-weight: normal;
  font-family: PingFangSC-Regular, sans-serif;
  color: #fff;
  font-size: .5625rem;
}

.main-4 {
  text-align: center;
  margin-top: .625rem;
  /* overflow: hidden; */
  /* padding: 0 .5313rem; */
}

.main-4 button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  font-size: .375rem;
}

.main-4 h3 {
  margin-top: 0;
  text-align: center;
  font-weight: normal;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .6933rem;
  margin-bottom: .625rem;
}

.main-4 .nav {
  padding: 0 .375rem;
  overflow: hidden !important;
}

.main-4 ul {
  text-align: left;
  /* overflow: hidden; */
  width: 16.875rem;
  height: 7.3438rem;
  background-color: pink;
}

.main-4 ul li {
  float: left;
  margin-right: .3125rem;
  /* width: 60%; */
  height: 7.3438rem;
  background-color: red;
}

.footer {
  position: relative;
  margin-top: 1.6rem;
  padding: 0 .5313rem;
  background-color: #4d73ff;
}

.footer ul {
  margin: 0;
  padding: 0;
}

.footer ul li {
  height: 2rem;
  line-height: 2rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-icon-arrow-right {
  font-size: .56rem;
  margin-right: -0.1rem;
  color: #fff;
}

.footer ul li p {
  font-size: .52rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.logn img {
  width: 5.625rem;
  height: 1.5625rem;
  margin-top: .625rem;
  margin-bottom: .625rem;
  /* width: ; */
  /* background-color: pink; */
}

.dianhua img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dianhua p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.dizhi {
  margin-top: .3125rem;
  margin-bottom: .625rem;
}

.dizhi img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dizhi p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.footer-bottom {
  border-top: 1px solid #eee;
  height: 1.4063rem;
}

.footer-bottom {
  padding-top: .3125rem;
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.aaa {
  display: block !important;
  position: fixed;
  top: 0;
  right: 0;
  width: 45%;
  height: 100%;
  background-color: #fff;
  z-index: 9999999999999;
}

.addbtn {
  width: 3.04rem;
  height: 1.2rem;
  background-color: #5d7bff !important;
  /* 不支持线性的时候显示 */
  background-image: linear-gradient(to right, #5d7bff, #7b9cff);
  border-radius: 2px;
  margin-bottom: 1.25rem;
  font-size: .56rem;
  color: #fff !important;
  border: 0;

}

.listiscolor {
  padding: 0 .5625rem;
  padding-top: .3467rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .5333rem;
  height: 4.28rem;
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.mask {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.maskis {
  display: block;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.listiscolor {
  padding: 0 1.04rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .3125rem;
  background-color: #fff;
  height: 3.5rem;
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.erweima1 {
  display: none;
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translate(-3.6rem, 3.6rem);
}

.erweima1 img {
  width: 7.2rem;
  height: 7.2rem;
}

.ismask {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;
}

.isnav {
  position: fixed;
  top: 2.4rem;
  right: 0;
  width: 9rem;
  height: 100%;
  background-color: #fff;

  ul {
    padding: 0 .48rem;

    li {
      height: 2.12rem;
      line-height: 2.12rem;
      color: #2c3e5c;
      font-size: .56rem;
      font-family: Arial, PingFangSC-Semibold, sans-serif;
      border-bottom: 1px solid #eee;
    }

    .subLi {
      padding-left: .58rem;
    }

    li:nth-child(1) {
      border-top: 1px solid #eee;
    }
  }
}

.hezuo {
  height: 8.06rem;
  background: url('../../../assets/images/手机关于我们/组32.png');
  background-size: 100%;
  overflow-y: auto;
  padding-top: .2rem;

  ul {
    margin-top: .4rem;
    width: 39.5rem;
    height: 2.02rem;

    li {
      float: left;
      width: 5.3rem;
      height: 2.02rem;
      margin-right: .4rem;

      img {
        width: 5.3rem;
        height: 2.02rem;
        object-fit: cover;
      }
    }

    li:nth-child(7) {
      margin-right: 0;
    }
  }
}

.iserweima {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;

  img {
    position: fixed;
    // width: 7.2rem;
    // height: 7.2rem;
    top: calc(50% - 90px);
    left: calc(50% - 90px);
    // transform: translate(-50%,-50%);
  }
}
</style>
